import api from '../utils/api';

const calendarApi = {
  // Get upcoming calendar events (next 7 days)
  getUpcomingEvents: async () => {
    const response = await api.get('/calendar/upcoming');
    return response.data;
  },

  // Get all birthdays
  getBirthdays: async () => {
    const response = await api.get('/calendar/birthdays');
    return response.data;
  },

  // Get all work anniversaries
  getAnniversaries: async () => {
    const response = await api.get('/calendar/anniversaries');
    return response.data;
  },

  // Get all holidays
  getHolidays: async (includeArchived = false) => {
    const response = await api.get(`/calendar/holidays?include_archived=${includeArchived}`);
    return response.data;
  },

  // Create holiday (admin only)
  createHoliday: async (holidayData) => {
    const response = await api.post('/calendar/holidays', holidayData);
    return response.data;
  },

  // Update holiday (admin only)
  updateHoliday: async (id, holidayData) => {
    const response = await api.put(`/calendar/holidays/${id}`, holidayData);
    return response.data;
  },

  // Delete holiday (admin only)
  deleteHoliday: async (id) => {
    const response = await api.delete(`/calendar/holidays/${id}`);
    return response.data;
  },

  // Archive/Unarchive holiday (admin only)
  archiveHoliday: async (id, isArchived) => {
    const response = await api.patch(`/calendar/holidays/${id}/archive`, { is_archived: isArchived });
    return response.data;
  },

  // Run archive process for past holidays (admin only)
  archivePastHolidays: async () => {
    const response = await api.post('/calendar/holidays/archive-past');
    return response.data;
  },

  // Update user profile (self-service)
  updateProfile: async (profileData) => {
    const response = await api.put('/auth/profile', profileData);
    return response.data;
  },

  // Admin update user profile
  updateUserProfile: async (userId, profileData) => {
    const response = await api.put(`/auth/users/${userId}/profile`, profileData);
    return response.data;
  }
};

export default calendarApi; 